import { FLOW_STATUS, FLOW_STATUS_NAMES } from '../types/Applications';
import { StepType } from '../types/Calls';
import { theme } from '../newTheme';
const { colors } = theme;
export const STATUS_CHIP_COLORS = {
    [FLOW_STATUS.DRAFT]: colors.neutral.light,
    [FLOW_STATUS.ASSIGNED]: colors.neutral.light,
    [FLOW_STATUS.TRIGGERED]: colors.neutral.light,
    [FLOW_STATUS.CHANGED_OWNER]: colors.neutral.light,
    [FLOW_STATUS.SUBMITTED]: colors.secondaries.light,
    [FLOW_STATUS.RESUBMITTED]: colors.secondaries.light,
    [FLOW_STATUS.CHANGES_REQUESTED]: colors.secondaries.medium,
    [FLOW_STATUS.CONFLICTED]: colors.secondaries.medium,
    [FLOW_STATUS.REVIEWED]: colors.tertiary,
    [FLOW_STATUS.ACCEPTED]: colors.success.light,
    [FLOW_STATUS.APPROVED]: colors.success.light,
    [FLOW_STATUS.ADMIN_APPROVED]: colors.success.light,
    [FLOW_STATUS.AWARDED]: colors.success.light,
    [FLOW_STATUS.REJECTED]: colors.errors.variable,
    [FLOW_STATUS.REFUSED]: colors.errors.variable,
    [FLOW_STATUS.REVOKED]: colors.errors.variable,
    [FLOW_STATUS.ADMIN_REJECTED]: colors.errors.variable,
    [FLOW_STATUS.NOT_AWARDED]: colors.errors.variable,
};
const REVIEW_CHIPS = {
    [StepType.technical_review]: { label: 'Technically Reviewed', color: colors.tertiary },
    [StepType.scientific_review]: { label: 'Scientifically Reviewed', color: colors.primaries.medium },
};
export const getStatusChip = (status, reviewType) => {
    const resolved = status || FLOW_STATUS.DRAFT;
    const reviewChip = resolved === FLOW_STATUS.REVIEWED && reviewType ? REVIEW_CHIPS[reviewType] : undefined;
    return reviewChip || { label: FLOW_STATUS_NAMES[resolved], color: STATUS_CHIP_COLORS[resolved] };
};
